<template>
  <v-menu min-width="500" offset-y>
    <template #activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" small icon width="60" @click="hideMainMenu()">
        <v-badge :value="badgeShow" :content="alertsCount" overlap class="contents-count">
          <v-icon small>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card class="card-wrap">
      <v-card class="pa-1 my-2 elevation-0">
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-data-table
          :headers="headers"
          :items="alerts"
          :items-per-page="showSize"
          :sort-by="['dateTime']"
          :sort-desc="[true]"
          @click:row="confirm"
          item-key="id"
          class="elevation-0 content"
          dense 
          hide-default-footer>
          <template v-slot:item.dateTime="{ item }">
            {{ item.dateTime | format('yyyy-MM-dd HH:mm:ss') }}
          </template>
          <template v-slot:item.target="{ item }"> {{ item.target }} </template>
          <template v-slot:item.message="{ item }">
            <span>
              <v-icon class="mr-1" :color="colors[item.level]" x-small>{{ icons[item.level] }}</v-icon>
            </span>
            <span>
              {{ item.message }}
            </span>
          </template>
        </v-data-table>
      </v-card>
    </v-card>
  </v-menu>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { mapState, mapActions } from 'vuex';
import bus from '@/utils/bus';
export default {
  data() {
    return {
      showSize: 20, // 목록 개수
      accumulatedAlerts: [], // 누적 데이터
      alerts: [], // 표시 데이터
      alertsCount: '', // 표시 개수
      headers: [
        { text: this.$t('analysis.alert.datetime'), value: 'dateTime', width: '132', sortable: false },
        { text: this.$t('analysis.alert.target'), value: 'target', sortable: false },
        { text: this.$t('analysis.alert.description'), value: 'message', sortable: false },
      ],
      colors: { 0: '#00ff00', 1: '#0085ff', 4: '#ffdd00', 5: '#ff0000' },
      icons: { 0: 'mdi-restore-alert', 1: 'mdi-information-outline', 4: 'mdi-alert', 5: 'mdi-alert-remove' },
      fields: ['sapYmdhms', 'stime', 'sstmId', 'instId', 'nodeId', 'alrtLevel', 'message'],
      badgeShow: false,
      interval: null,
    };
  },
  computed: {
    ...mapState('common/user', ['alertConfirmTime']),
  },
  watch: {
    accumulatedAlerts: {
      deep: true,
      handler(value) {
        if (value.length && !this.badgeShow) {
          this.twinkling(true);
        } else {
          this.twinkling(false);
          this.badgeShow = false;
        }
      },
    },
  },
  methods: {
    ...mapActions('common/user', ['setAlertConfirmTime']),
    // BEGIN::Added.by.KWShin.2024.07.05.
    hideMainMenu() {
      bus.$emit('toggle-main-menu', false);
    },
    // FINISH::Added.by.KWShin.2024.07.05.
    twinkling(active) {
      if (active) {
        clearInterval(this.interval);
        this.interval = setInterval(() => {
          if (this.alertsCount !== '0' && this.alertsCount !== '') {
            this.badgeShow = !this.badgeShow;
          } else {
            this.badgeShow = false;
          }
        }, 1000);
      } else {
        clearInterval(this.interval);
      }
    },
    wsBufferedDataHandler(key, responses) {
      responses.forEach(response => {
        this.add(response.map(r => this.item(r.data[0])));
      });
    },
    wsDataHandler(key, response) {
      this.add([this.item(response[0])]);
    },
    item(row) {
      return {
        id: uuidv4(),
        target: `${row.sstmId}_${row.instId}`,
        stime: row.stime,
        dateTime: parseInt(row.stime),
        level: parseInt(row.alrtLevel),
        message: row.message,
      };
    },
    add(rows) {
      this.accumulatedAlerts = this.accumulatedAlerts.concat(rows).filter(a => parseInt(a.stime) > this.alertConfirmTime);
      this.alertsCount = this.accumulatedAlerts.length > 99 ? '99+' : this.accumulatedAlerts.length.toString();
      this.alerts = this.alerts
        .concat(rows)
        .filter(a => parseInt(a.stime) > this.alertConfirmTime)
        .sort((a, b) => parseInt(b.stime) - parseInt(a.stime))
        .slice(0, this.showSize);
    },
    confirm(alert) {
      this.setAlertConfirmTime(new Date().getTime());
      this.alertsCount = '0';
      this.alerts = [];

      const path = `/views/analysis/alert?dt=${alert.dateTime}&trgt=${alert.target}`;
      if (path !== this.$route.path) this.$router.push({ path });
    },
  },
  created() {
    this.$websocket.alert.connect();
    const handler = {
      buffer: this.wsBufferedDataHandler,
      every: this.wsDataHandler,
    };
    const abapChildren = system =>
      system.abapInstances.map(instance => ({
        key: { name: 'rawAlrt', sstmId: system.id, instId: instance.id },
        fields: this.fields,
        handler,
      }));
    const javaChildren = system =>
      system.javaInstances.reduce(
        (acc, instance) =>
          acc.concat(
            instance.nodes.map(node => ({
              key: { name: 'rawAlrt', sstmId: system.id, instId: instance.id, nodeId: node.id },
              fields: this.fields,
              handler,
            })),
          ),
        [],
      );
    const systemIds = this.$store.state.common.user.targetMonitoringSystemIds;
    const systems = this.$store.state.common.system.systems.filter(system => systemIds.includes(system.id));
    const requests = systems.reduce((requests, system) => requests.concat(system.stackType == 'ABAP' ? abapChildren(system) : javaChildren(system)), []);
    this.$websocket.alert.send({ requests });
  },
  beforeDestroy() {
    this.$websocket.alert.close();
  },
};
</script>
